(function ProductChooseAddon() {
  'use strict'; 

  var selectors = {
    quantityInput: '[data-multi-product-variant-quantity]',
    crossSellSourceInput: '[data-multi-product-variant-cross-sell-source]',
    variantIdInput: '[data-multi-product-variant-id]',
    itemContainer: '[data-product-multi-select-item-container]',
    showFirstContainer: '[data-multi-select-show-first]',
  };
  var attributes = {
    colorInputProductId: 'data-multi-select-color-product-id',
    variantInputProductId: 'data-multi-product-product-id',
    imageVariantId: 'data-image-variant-id',
    addonPrice: 'data-multi-product-addon-price',
    mainProductPrice: 'data-product-price',
    mainProductCompareAtPrice: 'data-compare-price',
  };

  window.addEventListener('change', handleColorInputChange);
  window.addEventListener('change', handleVariantInputChange);
  window.addEventListener('variant:change', updateMainProductPrices);
  window.POV && window.POV.Cart 
    ? incrementInputIndexes()
    : window.addEventListener('cart:init', incrementInputIndexes);

  function handleColorInputChange(event) {
    if (!event.target.hasAttribute(attributes.colorInputProductId)) return;
    updateVariantIdInput(event.target);
    updateImage(event.target);
  }

  function handleVariantInputChange(event) {
    if (!event.target.matches(selectors.variantIdInput)) return;
    handleShowFirst();
    handleHiddenInputs();
    updateMainProductPrices();
  }

  // Increment the input indexes so addons are added correctly when bonus items are present
  function incrementInputIndexes() {

    var quantityInputElements = nodeList(selectors.quantityInput);
    var crossSellSourceInputElements = nodeList(selectors.crossSellSourceInput);
    nodeList(selectors.variantIdInput).forEach(function(variantIdInput, index) {
      var bonusItemsLength = document.querySelectorAll(POV.Cart.selectors.bonusItemInput).length;
      var correctIndex = index + bonusItemsLength + 1;
      var quantityInput = quantityInputElements[index];
      var crossSellSourceInput = crossSellSourceInputElements[index];
      variantIdInput.setAttribute('name', 'items[' + correctIndex + ']id');
      quantityInput.setAttribute('name', 'items[' + correctIndex + ']quantity');
      crossSellSourceInput.setAttribute('name', 'items[' + correctIndex + ']properties[_cross_sell_source]');
    });
  }

  // Update the variant id input with the selected color's variant id and price
  function updateVariantIdInput(colorInputElement) {
    var colorVariantId = colorInputElement.value;
    var productId = colorInputElement.getAttribute(attributes.colorInputProductId);
    var variantIdInput = document.querySelector('['+attributes.variantInputProductId+'="' + productId + '"]');
    variantIdInput.value = colorVariantId;
  }

  // Update the product image to the selected color
  function updateImage(colorInputElement) {
    var selectedVariantId = colorInputElement.value;
    var container = colorInputElement.closest(selectors.itemContainer);
    var images = nodeList('['+attributes.imageVariantId+']', container);
    images.forEach(function(image) {
      var imageVariantId = image.getAttribute(attributes.imageVariantId);
      image.classList.toggle('hidden', imageVariantId !== selectedVariantId);
    }); 
  }

  // Update main product price and compare_at price to include the selected addon prices
  function updateMainProductPrices() {
    var multiSelectTotalCents = 0;
    nodeList(selectors.variantIdInput+':checked').forEach(function(input) {
      var addonPriceCents = parseInt(input.getAttribute(attributes.addonPrice));
      multiSelectTotalCents += addonPriceCents;
    });

    var mainProductPriceElement = document.querySelector('['+attributes.mainProductPrice+']');
    var mainProductPriceCents = parseInt(mainProductPriceElement.getAttribute(attributes.mainProductPrice));
    nodeList('['+attributes.mainProductPrice+']').forEach(function(priceElement) {;
      priceElement.innerHTML = POV.Currency.formatMoney(mainProductPriceCents + multiSelectTotalCents, POV.Liquid.moneyFormat);
    });

    var mainProductCompareAtPriceElement = document.querySelector('['+attributes.mainProductCompareAtPrice+']');
    var mainProductCompareAtPriceCents = parseInt(mainProductCompareAtPriceElement.getAttribute(attributes.mainProductCompareAtPrice));
    nodeList('['+attributes.mainProductCompareAtPrice+']').forEach(function(compareAtPriceElement) {;
      compareAtPriceElement.innerHTML = mainProductCompareAtPriceCents > 0
        ? POV.Currency.formatMoney(mainProductCompareAtPriceCents + multiSelectTotalCents, POV.Liquid.moneyFormat)
        : '';
    });
  }

  // Enable/Disable hidden inputs so they are included/excluded from the form submission
  function handleHiddenInputs(){
    nodeList(selectors.variantIdInput).forEach(function(input) {
      var quantityInput = input.closest(selectors.itemContainer).querySelector(selectors.quantityInput);
      var crossSellSourceInput = input.closest(selectors.itemContainer).querySelector(selectors.crossSellSourceInput);
      quantityInput.disabled = !input.checked;
      crossSellSourceInput.disabled = !input.checked;
    });
  }

  // Show more addon products after the first product is checked
  function handleShowFirst(){
    var container = document.querySelector(selectors.showFirstContainer);
    if (!container) return;
    var firstMultiInput = container.querySelector('.product-multi-select-item:first-of-type input[type="checkbox"]');
    if(!firstMultiInput) return;

    if(firstMultiInput.checked) {
      container.classList.remove('multi-select-show-first');
    } else {
      container.classList.add('multi-select-show-first');
      nodeList('.product-multi-select-item:not(:first-of-type) input[type="checkbox"]').forEach(function(input){
        input.checked = false;
      });
    }
  }

})();